import React from 'react';
import WhatsAppIcon from './WhatsAppIcon';
import { useTranslation } from 'react-i18next';

// Premium inline WhatsApp CTA — used inside pages (e.g. under the hero
// search box) as a secondary call-to-action.
const WhatsAppCTA = ({
    number = '971521138999',
    message = 'Hello, I need help finding a property.',
    label,
    align = 'center',
    style = {}
}) => {
    const { t } = useTranslation();
    const href = `https://wa.me/${number}?text=${encodeURIComponent(message)}`;
    const text = label || t('hero.whatsapp_help') || 'Need Help Finding a Property? Chat on WhatsApp';

    return (
        <>
            <style>{`
                .wa-cta {
                    display: inline-flex;
                    align-items: center;
                    gap: 12px;
                    padding: 14px 26px;
                    color: #fff;
                    text-decoration: none;
                    background: linear-gradient(135deg, rgba(37, 211, 102, 0.18) 0%, rgba(18, 140, 126, 0.14) 100%);
                    border: 1px solid rgba(37, 211, 102, 0.55);
                    border-radius: 999px;
                    font-weight: 600;
                    font-size: 0.95rem;
                    letter-spacing: 0.01em;
                    backdrop-filter: blur(14px);
                    -webkit-backdrop-filter: blur(14px);
                    box-shadow: 0 8px 24px rgba(37, 211, 102, 0.18),
                                0 0 0 1px rgba(255, 255, 255, 0.04) inset;
                    transition: transform 0.25s cubic-bezier(0.16, 1, 0.3, 1),
                                box-shadow 0.25s ease,
                                background 0.25s ease,
                                border-color 0.25s ease;
                }

                .wa-cta:hover,
                .wa-cta:focus-visible {
                    transform: translateY(-2px);
                    background: linear-gradient(135deg, rgba(37, 211, 102, 0.28) 0%, rgba(18, 140, 126, 0.22) 100%);
                    border-color: rgba(37, 211, 102, 0.85);
                    box-shadow: 0 14px 34px rgba(37, 211, 102, 0.28),
                                0 0 0 1px rgba(255, 255, 255, 0.08) inset;
                }

                .wa-cta:active {
                    transform: translateY(0) scale(0.985);
                }

                .wa-cta-icon {
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    width: 30px;
                    height: 30px;
                    border-radius: 50%;
                    background: linear-gradient(135deg, #25D366 0%, #128C7E 100%);
                    flex-shrink: 0;
                    box-shadow: 0 2px 8px rgba(37, 211, 102, 0.4);
                }

                @media (max-width: 480px) {
                    .wa-cta {
                        font-size: 0.85rem;
                        padding: 12px 20px;
                        gap: 10px;
                    }
                    .wa-cta-icon { width: 26px; height: 26px; }
                }
            `}</style>

            <div style={{ display: 'flex', justifyContent: align, width: '100%', ...style }}>
                <a
                    href={href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="wa-cta"
                    aria-label={text}
                >
                    <span className="wa-cta-icon" aria-hidden="true">
                        <WhatsAppIcon size={16} />
                    </span>
                    <span>{text}</span>
                </a>
            </div>
        </>
    );
};

export default WhatsAppCTA;
